import { LitElement } from 'lit';
import { unsafeStatic, html } from "lit/static-html.js";
import { i18n } from '@lingui/core';
import { messages as nbMessages} from '../src/raw/mitt-anbud-light/locales/nb/messages.mjs';
import { messages as enMessages} from '../src/raw/mitt-anbud-light/locales/en/messages.mjs';
import { messages as fiMessages} from '../src/raw/mitt-anbud-light/locales/fi/messages.mjs';
import { messages as daMessages} from '../src/raw/mitt-anbud-light/locales/da/messages.mjs';
import { messages as svMessages} from '../src/raw/mitt-anbud-light/locales/sv/messages.mjs';
import { activateI18n } from '../src/utils/i18n';
activateI18n(enMessages, nbMessages, fiMessages, daMessages, svMessages);


export class IconMittAnbudLight42 extends LitElement {
  render() {
      const title = i18n.t({ message: `MittAnbud`, id: 'icon.title.mittanbudlight', comment: 'Title for MittAnbudLight icon' });
      
      return html`<svg xmlns="http://www.w3.org/2000/svg"width="42"height="28"fill="none"viewBox="0 0 42 28" part="w-icon-mitt-anbud-light-42-part">${unsafeStatic(`<title>${title}</title>`)}<path fill="#101F41" d="M17.08 1.961 7.002 12.007l2.8 2.791 10.08-10.046-2.8-2.79Z"></path><path fill="#3960BF" d="M15.96 10.89a3.967 3.967 0 0 0 5.6 0l3.36-3.348 7.28 7.256 2.8-2.79L24.92 1.96z"></path><path fill="#101F41" d="M22.68 12.007a5.553 5.553 0 0 1-7.839 0l-3.92 3.907 10.08 10.047 1.68-1.675-3.92-3.907 1.12-1.116 3.92 3.907 1.68-1.675-3.92-3.906 1.12-1.117 3.92 3.907 1.68-1.674-3.92-3.907 1.12-1.116 3.92 3.907 1.68-1.675-6.16-6.14z"></path></svg>`; }
}
if (!customElements.get('w-icon-mitt-anbud-light-42')) {
  customElements.define('w-icon-mitt-anbud-light-42', IconMittAnbudLight42);
}